import React from 'react';
import i18next from 'core/i18n';
import { AgFinancingPhase2Status, Phase2 } from '@indigo-ag/schema';
import { Body, palettes, TinyTitle } from '@indigo-ag/component-module';

import {
  NotificationSection,
  NotificationSectionStatus
} from '../../../shared/NotificationSection/NotificationSection';

const phase2NotificationStateTitles: { [key in AgFinancingPhase2Status]?: string } = {
  [AgFinancingPhase2Status.ON_HOLD]: `${i18next.t('phase')} 2 ${i18next.t('onHold')}`,
  [AgFinancingPhase2Status.DENIED]: i18next.t('phase2Denied'),
  [AgFinancingPhase2Status.WAITING_COMMITTEE_DECISION]: i18next.t('phase2WaitingCommittee')
};

interface Phase2StateProps {
  phaseInfo?: Phase2;
}

export const Phase2State: React.FunctionComponent<Phase2StateProps> = ({ phaseInfo }) => {
  const getNotificationStatus = (): NotificationSectionStatus => {
    return phaseInfo?.status === AgFinancingPhase2Status.DENIED ? 'error' : 'warning';
  };

  return (
    <NotificationSection
      status={getNotificationStatus()}
      title={(phaseInfo?.status && phase2NotificationStateTitles[phaseInfo.status]) || ''}
      updatedAt={phaseInfo?.decisionChangedAt}
      updateBy={phaseInfo?.decisionChangedBy}
    >
      {phaseInfo?.decisionNotes && (
        <>
          <TinyTitle className="mt-2 mb-1 text-transform-capitalize" style={{ color: palettes.brand.gray[700] }}>
            {i18next.t('comments')}
          </TinyTitle>
          <Body className="mt-1">{phaseInfo?.decisionNotes}</Body>
        </>
      )}
    </NotificationSection>
  );
};
